import React from "react";

const AddressPopUp = ({ isShowShipping, setIsShowShipping, shippingData }) => {
  const { city, country, house, name, mobile, postalCode, road } =
    shippingData !== "" && shippingData;
  return (
    <div
      className={` ${
        isShowShipping ? "popupShipping show-popUp-shipping" : "popupShipping"
      }`}
    >
      <div className="shippingpopupboxdetails admin-check-shipping-address">
        <p
          className="order-shipping-title"
          style={{ textDecoration: "underline", color: "" }}
        >
          Address of Shipping:
        </p>
        <h3>Name: {name}</h3>
        <h4>Mobile: {mobile}</h4>
        <h5>Country: {country}</h5>
        <h5>City: {city}</h5>
        <h4>Road: {road}</h4>
        <h5>Postal Code: {postalCode}</h5>
        <h5>House Holding No. {house || "not given"} </h5>
        <button onClick={() => setIsShowShipping(false)}>Close</button>
      </div>
    </div>
  );
};

export default AddressPopUp;
// {house || "not given"}
